import { getMinMaxDataTime } from '@/utils/function';
import routeClass from './route-class';

export default class extends routeClass {
	constructor(options = {}, props = {}) {
		if (Object.keys(props || {}).length === 0) {
			props = {
				recordStart: 1,
				maxCount: 10,
				orderBy: 'timestamp',
				orderDirection: 'desc',
				search: '',
				minDatetime: getMinMaxDataTime(-7),
				maxDatetime: getMinMaxDataTime(),
				changedByUserId: ''
			};
		}
		super(options, props);
	}

	path = (path = null) => {
		path = path || this.basePath;

		const result = path + '/:id?/:name?' + this.getPropPath();
		return result;
	};
}
